import { Controller } from "stimulus"
import { fetchJSON } from "../lib/fetch_json"

export default class extends Controller {
  static targets = ["field", "saveIndicator"]
  static values = { updateUrl: String, deleteUrl: String, ticketTypeId: Number }

  connect() {
    this._saveTimeout = null
    this._dirty = false
  }

  disconnect() {
    clearTimeout(this._saveTimeout)
  }

  onFieldChange() {
    this._dirty = true
    this.showSaveState("dirty")
    clearTimeout(this._saveTimeout)
    this._saveTimeout = setTimeout(() => this.triggerSave(), 800)
  }

  async triggerSave() {
    if (!this._dirty) return

    this.showSaveState("saving")
    const payload = {}
    this.fieldTargets.forEach(field => {
      const name = field.dataset.fieldName
      if (!name) return
      if (field.type === "checkbox") {
        payload[name] = field.checked
      } else if (field.tagName === "TEXTAREA") {
        payload[name] = field.value
      } else {
        payload[name] = field.value
      }
    })

    try {
      const data = await fetchJSON(this.updateUrlValue, {
        method: "PATCH",
        body: { package: payload }
      })
      if (data.errors) {
        this.showSaveState("error")
      } else {
        this._dirty = false
        this.showSaveState("saved")
        document.dispatchEvent(new CustomEvent("opp-editor:saved", {
          detail: { section: "tickets", completion: data.completion }
        }))
      }
    } catch (e) {
      this.showSaveState("error")
    }
  }

  async confirmDelete() {
    if (!confirm("Are you sure you want to delete this ticket type? This cannot be undone.")) return

    try {
      const data = await fetchJSON(this.deleteUrlValue, { method: "DELETE" })
      if (data.success) {
        this.element.style.transition = "opacity 0.3s, max-height 0.3s"
        this.element.style.opacity = "0"
        this.element.style.maxHeight = "0"
        this.element.style.overflow = "hidden"
        setTimeout(() => {
          this.element.remove()
          // Notify parent list controller
          document.dispatchEvent(new CustomEvent("opp-editor:package-deleted"))
          document.dispatchEvent(new CustomEvent("opp-editor:saved", {
            detail: { section: "tickets", completion: data.completion }
          }))
        }, 300)
      }
    } catch (e) {
      alert("Failed to delete: " + e.message)
    }
  }

  showSaveState(state) {
    if (!this.hasSaveIndicatorTarget) return
    const el = this.saveIndicatorTarget
    el.classList.remove("d-none")
    switch (state) {
      case "dirty":
        el.innerHTML = '<span class="text-muted"><i class="fas fa-pencil-alt fa-sm"></i></span>'
        break
      case "saving":
        el.innerHTML = '<span class="text-info"><i class="fas fa-spinner fa-spin fa-sm"></i></span>'
        break
      case "saved":
        el.innerHTML = '<span class="text-success"><i class="fas fa-check fa-sm"></i></span>'
        setTimeout(() => { if (!this._dirty) el.classList.add("d-none") }, 2000)
        break
      case "error":
        el.innerHTML = '<span class="text-danger"><i class="fas fa-exclamation-circle fa-sm"></i></span>'
        break
    }
  }
}
